import * as yup from "yup";

import { FIELD_NAMES, OTP_LENGTH } from "./VerifyOtp.constants";

export default function formValidationSchema() {
  return yup.object().shape({
    [FIELD_NAMES.TOKEN]: yup
      .string()
      .matches(
        new RegExp(`^\\d{${OTP_LENGTH}}$`),
        `Enter the ${OTP_LENGTH}-digit code from your email`
      )
      .required("Verification code is required"),
  });
}
